import InitializeLayout from '@js/layout';

import CollaborativeNewManager from '@js/managers/collaborativeNewManager';

InitializeLayout();

CollaborativeNewManager.initialize();
